import React, { useCallback, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ScopeProvider, useScope } from '../components/ScopeProvider';
import PadroesTab from './escalas/PadroesTab';
import AtribuicoesTab from './escalas/AtribuicoesTab';
import ExcecoesTab from './escalas/ExcecoesTab';
import CalendarioTab from './escalas/CalendarioTab';
import useLookups from './escalas/useLookups';
import './Configuracoes.css';
import './escalas/Escalas.css';

/**
 * Menu Escalas: padrões de escala (5x2, 6x1, 12x36…), atribuições em cascata, exceções (vendedor,
 * loja, nacional) e o calendário resolvido. Plano e contrato: docs/escalas.md no aliado-recorder-api.
 *
 * Só a empresa vem do escopo compartilhado (ScopeProvider): fase e loja não fazem sentido aqui, o
 * alvo da escala é escolhido dentro de cada aba. A trava de verdade está nas ROTAS: o BFF exige
 * portal admin e injeta o `user_id_admin` da sessão, e a API confere role=admin de novo.
 */
const ABAS = [
    { key: 'padroes', label: 'Padrões', Componente: PadroesTab },
    { key: 'atribuicoes', label: 'Atribuições', Componente: AtribuicoesTab },
    { key: 'excecoes', label: 'Exceções', Componente: ExcecoesTab },
    { key: 'calendario', label: 'Calendário', Componente: CalendarioTab },
];

function Conteudo({ aba, user }) {
    const navigate = useNavigate();
    const { subdomain, setSubdomain, companies } = useScope();
    const [toast, setToast] = useState(null);
    const timer = useRef(null);
    const notify = useCallback((msg, type = 'info') => {
        setToast({ msg, type });
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setToast(null), 4500);
    }, []);

    const lookups = useLookups(subdomain, user, notify);
    const atual = ABAS.find((a) => a.key === aba) ? aba : ABAS[0].key;
    const { Componente } = ABAS.find((a) => a.key === atual);

    return (
        <div className="cfg-page">
            {toast && <div className={`esc-toast esc-toast-${toast.type}`} role="status">{toast.msg}</div>}
            <header className="cfg-header">
                <h1>Escalas</h1>
                <p className="cfg-sub">
                    Cadastre os padrões de escala, diga quem usa cada um e marque as exceções. A escala de um dia sai
                    da atribuição mais específica (vendedor, loja, unidade, empresa) e as exceções sobrepõem na ordem
                    vendedor, loja, nacional.
                </p>
            </header>

            <div className="esc-empresa">
                <label htmlFor="esc-empresa-sel">Empresa</label>
                <select id="esc-empresa-sel" value={subdomain} onChange={(e) => setSubdomain(e.target.value)}>
                    {companies.map((c) => <option key={c.subdomain} value={c.subdomain}>{c.name || c.subdomain}</option>)}
                </select>
            </div>

            <nav className="cfg-abas">
                {ABAS.map((a) => (
                    <button key={a.key} className={`cfg-aba ${a.key === atual ? 'cfg-aba-ativa' : ''}`}
                        onClick={() => navigate(`/escalas/${a.key}`)}>
                        {a.label}
                    </button>
                ))}
            </nav>

            {!subdomain
                ? <p className="cfg-vazio">Selecione uma empresa.</p>
                : <Componente key={`${atual}:${subdomain}`} subdomain={subdomain} user={user} lookups={lookups} notify={notify} />}
        </div>
    );
}

function Escalas({ user }) {
    const { aba } = useParams();
    return (
        <ScopeProvider>
            <Conteudo aba={aba} user={user} />
        </ScopeProvider>
    );
}

export default Escalas;
